export default "__VITE_ASSET__DBo66kMJ__"